import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from'@material-ui/core/ListItemIcon';
import { Dashboard, Storage, ShoppingCart, Assignment } from '@material-ui/icons';
import { Link } from 'react-router-dom';

const style = () => ({
    list: {
        width: 250,
    },
    menuItem: {
        textDecoration: 'none',
    }
});

const RoofSnapDrawer = (props) => {
    const isSketchOsAdmin = !!(props.currentUserRoles.isAdmin || props.currentUserRoles.isSketchOsAdmin);

    return (
        <Drawer
            open={props.open}
            onClose={props.onToggle}
        >
            <div className={props.classes.list}>
                <Link to="/" className={props.classes.menuItem}>
                    <MenuItem onClick={props.onToggle}>
                        <ListItemIcon>
                            <Dashboard />
                        </ListItemIcon>
                        <ListItemText primary="Dashboard" />
                    </MenuItem>
                </Link>
                {
                    isSketchOsAdmin &&
                    <Link to="/orders" className={props.classes.menuItem}>
                        <MenuItem onClick={props.onToggle}>
                            <ListItemIcon>
                                <ShoppingCart />
                            </ListItemIcon>
                            <ListItemText primary="Orders" />
                        </MenuItem>
                    </Link>
                }
                <Link to="/queue" className={props.classes.menuItem}>
                    <MenuItem onClick={props.onToggle}>
                        <ListItemIcon>
                            <Storage />
                        </ListItemIcon>
                        <ListItemText primary="Queue" />
                    </MenuItem>
                </Link>
                <Link to="/myorders" className={props.classes.menuItem}>
                    <MenuItem onClick={props.onToggle}>
                        <ListItemIcon>
                            <Assignment />
                        </ListItemIcon>
                        <ListItemText primary="My Orders" />
                    </MenuItem>
                </Link>
            </div>
        </Drawer>
    );
};

RoofSnapDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    currentUserRoles: PropTypes.shape({
        isAdmin: PropTypes.bool.isRequired,
        isSketchOsAdmin: PropTypes.bool.isRequired,
        isSketchTech: PropTypes.bool.isRequired,
    }).isRequired,
    classes: PropTypes.shape({
        list: PropTypes.string.isRequired,
        menuItem: PropTypes.string.isRequired,
    }).isRequired,
};

export default withStyles(style)(RoofSnapDrawer);
